import { DateTime } from "luxon";

import { ShiftLockState } from "../utilities/helpers/shiftLockStateHelpers";
import { ajaxController } from "./controller/AjaxController";
import { ShiftExistenceResponseDTO } from "../DTOs/Settings/ShiftExistenceDTO";
import { RoleConfig } from "../DTOs/Settings/RoleConfigDto";
import { ShiftLetter } from "../types/Shift";

class SettingsAjax {
  private _ajaxController = ajaxController
  private _settingsDataEndpoint = "/Settings"

  public getTimezoneSettings() {
    return this._ajaxController.get<{ timezoneId: string }>(
      `${this._settingsDataEndpoint}/timezone`,
      {}
    )
  }

  public getShiftBoundaries(shiftDate: DateTime, dayOrNight: ShiftLetter) {
    return this._ajaxController.get<{ shiftStart: DateTime, shiftEnd: DateTime }>(
      `${this._settingsDataEndpoint}/shift-boundaries/${shiftDate.toISODate()}/${dayOrNight}`,
      {}
    )
  }

  public getShiftEditability(shiftDate: DateTime, dayOrNight: ShiftLetter) {
    return this._ajaxController.get<{ isLocked: boolean; canToggleLock: boolean; isPastAutoLockCutOff: boolean | null; exists?: boolean }>(
      `${this._settingsDataEndpoint}/shift-editability/${shiftDate.toISODate()}/${dayOrNight}`,
      {}
    )
  }

  public getShiftLockInfo() {
    return this._ajaxController.get<ShiftLockState>(
      `${this._settingsDataEndpoint}/shift-lock-info`,
      {},
    )
  }

  public unlockShift(shiftDate: DateTime, dayOrNight: ShiftLetter) {
    return this._ajaxController.post<{}, { isLocked: boolean; canToggleLock: boolean; isPastAutoLockCutOff: boolean | null }>(
      `${this._settingsDataEndpoint}/shifts/${shiftDate.toISODate()}/${dayOrNight}/unlock`,
      {}
    )
  }

  public relockShift(shiftDate: DateTime, dayOrNight: ShiftLetter) {
    return this._ajaxController.post<{}, { isLocked: boolean; canToggleLock: boolean; isPastAutoLockCutOff: boolean | null }>(
      `${this._settingsDataEndpoint}/shifts/${shiftDate.toISODate()}/${dayOrNight}/relock`,
      {}
    )
  }

  public getShiftExistence(dateFromIso: string, dateToIso: string) {
    return this._ajaxController.get<ShiftExistenceResponseDTO>(
      `${this._settingsDataEndpoint}/shifts/existence`,
      { dateFrom: dateFromIso, dateTo: dateToIso }
    );
  }

  public getRoleConfig() {
    return this._ajaxController.get<RoleConfig>(
      `${this._settingsDataEndpoint}/role-config`,
      {}
    );
  }

  public getSectionNames() {
    return this._ajaxController.get<Record<string, string>>(
      `${this._settingsDataEndpoint}/section-names`,
      {}
    );
  }

  public setSectionName(sectionKey: string, displayName: string | null) {
    return this._ajaxController.put<{ displayName: string | null }, string | null>(
      `${this._settingsDataEndpoint}/section-names/${sectionKey}`,
      { displayName }
    );
  }
}

export const settingsAjax = new SettingsAjax();